<template>
    <div class="my-record-container">


        <van-tabs class="mt-56" v-model="active" color="#ed6a0c">
            <van-tab title="Daily" >
                <MyRecordDetail :date-type="1" :oil-type="oilType"/>
            </van-tab>

            <van-tab title="Weekly">
                <MyRecordDetail :date-type="2" :oil-type="oilType"/>
            </van-tab>
            <van-tab title="Month">
                <MyRecordDetail :date-type="3" :oil-type="oilType"/>
            </van-tab>
        </van-tabs>

        <div class="toolbar pt-16 pb-16">
            <div class="back-container">
                <span class="back" @click="backClick"></span>
            </div>
            <div class="title-with-icon">
                <van-popover
                        v-model="showPopover"
                        trigger="click"
                        theme="dark"
                        :actions="smokeOilType"
                        @select="onSelect"
                >
                    <template #reference>
                        <span type="primary">{{oilTypeName}}</span>
                    </template>
                </van-popover>
            </div>
            <div class="right-menu"></div>
        </div>
    </div>
</template>

<script>

    import PillarContainer from "./PillarContainer"
    import apiService from "../repository/api/ApiService"
    import deviceRepository from "../repository/store/DeviceRepository"
    import log from "../repository/log/log"
    import {clearToast, loading} from "../util/util"
    import MyRecordDetail from "./MyRecordDetail"
    import Toast from "vant/es/toast"

    const echarts = require('echarts');
    export default {
        name      : "MyRecord",
        components: {MyRecordDetail, PillarContainer},
        data() {
            return {
                active      : "1",
                oilType     : 0,
                smokeOilType: [],
                showPopover : false,
                actions     : [],
                oilTypeName : 'All'
            }
        },
        methods   : {
            backClick() {
                this.$router.back()
            },

            onSelect(action) {
                const id     = action.item.id
                this.oilType = id
                this.oilTypeName = action.item.typeName
            },
            onOilTypeClick() {
                this.showPopover = true
            }
        },
        mounted() {
            deviceRepository.smokeOilType()
                .then(data => {
                    data.forEach(item => {
                        this.smokeOilType.push({text: item.typeName, item})
                    })
                })
        },
        computed  : {}
    }
</script>

<style lang="scss" scoped>
    .my-record-container {
        display: flex;
        flex-direction: column;
    }

    .title {
        flex: 4;
        font: 18px bold;
        margin-right: 11px;
        text-align: center;

        ::after {
            width: 13px;
            height: 7px;
            margin-left: 8px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: cover;
            @include bg-image("../assets/ic_bottom_expand");
        }
    }


</style>